export default class OriginSystem {
  id:string;

  name: string;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
  }

  public static system(value: any): OriginSystem {
    return new OriginSystem(value || {});
  }

  public static systemList(response: any): OriginSystem[] {
    return response.data.map(this.system);
  }

  public static fromName(actualName: string) {
    return new OriginSystem({ name: actualName });
  }
}
